import React from 'react';
import { GiftIcon as StyledGiftIcon } from './GiftIcon.styled';

export interface GiftIconProps {
  className?: string;
}

export function GiftIcon({ className }: GiftIconProps) {
  return <StyledGiftIcon className={className} />;
}
